var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreBlogger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 18.75c0 .69-.56 1.25-1.25 1.25h-17.5c-.69 0-1.25-.56-1.25-1.25v-17.5c0-.69.56-1.25 1.25-1.25h17.5c.69 0 1.25.56 1.25 1.25z",
    fill: "#021235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.25 11.25c0-1.875-.625-2.5-2.5-2.5v-1.875c0-1.865-1.875-3.125-3.125-3.125h-3.125c-2.18 0-3.75 1.578-3.75 3.75v5c0 2.167 1.57 3.75 3.75 3.75h5c2.178 0 3.737-1.582 3.75-3.75zm-8.438-4.375h2.5c.518 0 .938.42.938.938 0 .517-.42.937-.938.937h-2.5c-.517 0-.937-.42-.937-.938 0-.517.42-.937.938-.937zm4.375 6.25h-4.373c-.518 0-.938-.42-.938-.938 0-.517.42-.937.938-.937h4.375c.517 0 .937.42.937.938 0 .517-.42.937-.938.937z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreBlogger);
export default __webpack_public_path__ + "static/media/store-blogger.a601055e42b8f12ef835bd6a5d6d3004.svg";
export { ForwardRef as ReactComponent };